import { jsx as _jsx } from "react/jsx-runtime";
import ImageNotSupported from "@mui/icons-material/ImageNotSupported";
import Box from "@mui/material/Box";
function Image(props) {
    const { src, alt } = props;
    if (src || alt) {
        return (_jsx(Box, { sx: { textAlign: "center", margin: "auto" }, children: _jsx(ImageNotSupported, { fontSize: "large", color: "disabled" }) }));
    }
    return (_jsx(Box, { sx: { textAlign: "center", margin: "auto" }, children: _jsx("img", { src: src, alt: alt }) }));
}
export default Image;
//# sourceMappingURL=Image.js.map